import type { ReactNode } from 'react';

interface AuthSuccessProps {
  children: ReactNode;
}

export function AuthSuccess({ children }: AuthSuccessProps): JSX.Element {
  return (
    <div
      role="status"
      className="mb-4 rounded-md border-2 border-emerald-700/30 bg-emerald-700/10 px-3 py-2.5 text-sm text-emerald-800 shadow-sm"
    >
      {children}
    </div>
  );
}
